import { fetchApi } from '@/lib/api';
import type { DataFreshnessResponse } from '@shared/types/data-freshness';

/** When each of the team's data sources last synced (data-freshness.mdc). */
export function getDataFreshness(options: { signal?: AbortSignal } = {}) {
  return fetchApi<DataFreshnessResponse>('/data-freshness', { signal: options.signal });
}
